module.exports = __webpack_public_path__ + "static/media/github-brands.06b7e22f.svg";